import { render, staticRenderFns } from "./m-roster-course.vue?vue&type=template&id=23a28330&scoped=true&"
import script from "./m-roster-course.ts?vue&type=script&lang=ts&"
export * from "./m-roster-course.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-course.scss?vue&type=style&index=0&id=23a28330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a28330",
  null
  
)

export default component.exports